module.exports = __webpack_public_path__ + "static/6-edd3fe8f08b4bd1c29a847332d47c782.jpeg";